'use strict';Object.defineProperty(exports,"__esModule",{value:true});// Container sizes
exports.default=['xx-small','x-small','small','medium','large','x-large','xx-large'];module.exports=exports['default'];
//# sourceMappingURL=Sizes.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/watson-react-components/dist/components/Sizes.js
// module id = 566
// module chunks = 0